// @flow

import React from 'react';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import type { BasicImage } from 'app/packages/pinterest-flow-types/image';
import { Box, Image, Mask } from 'gestalt';

const CHIP_SIZE = 76;

type Chip = {
  id: string,
  images: {
    '750x': BasicImage,
  },
};

type Props = {
  // Chips will always be an array of 3 images
  chips: Array<Chip>,
};

function PinRepChips({ chips }: Props) {
  return (
    <Box display="flex" direction="row" justifyContent="between">
      {chips.map((chip: Chip) => {
        const image = chip.images['750x'] || {};
        return (
          <Box marginTop={1} key={chip.id}>
            <NavigateLink stopPropagation to={`/pin/${chip.id}/`}>
              <Mask shape="rounded" width={CHIP_SIZE} height={CHIP_SIZE} wash>
                <Image
                  alt=""
                  naturalHeight={image.height}
                  naturalWidth={image.width}
                  src={image.url}
                  fit="cover"
                />
              </Mask>
            </NavigateLink>
          </Box>
        );
      })}
    </Box>
  );
}

export default PinRepChips;
